module.exports = __webpack_public_path__ + "static/media/IMG_20190407_154058.1d4484bd.jpg";